import { render } from "./PaginaDemo.vue?vue&type=template&id=38f480a2&scoped=true"
import script from "./PaginaDemo.vue?vue&type=script&lang=js"
export * from "./PaginaDemo.vue?vue&type=script&lang=js"

import "./PaginaDemo.vue?vue&type=style&index=0&id=38f480a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f480a2"]])

export default __exports__